module.exports = __webpack_public_path__ + "static/media/business_financing.509a1453.png";